import React from "react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { Info, Coins } from 'lucide-react';

const AffiliatePromoBanner = () => (
  <TooltipProvider>
    <section className="w-full flex justify-center my-8">
      <div className="bg-gaming-dark border border-gaming-blue/40 rounded-lg px-6 py-6 max-w-2xl w-full flex flex-col items-center text-center shadow-lg">
        <div className="flex flex-col items-center mb-2">
          <div className="mb-2 p-2 rounded-full bg-gaming-blue/10 border border-gaming-blue/30">
            <Coins className="h-7 w-7 text-gaming-green" />
          </div>
          <span className="font-bold uppercase tracking-wide text-xs text-white/80 mb-1" style={{ letterSpacing: 1 }}>Affiliate Program</span>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 font-display">
          Earn up to 
          <span className="text-gaming-green ml-2">15% commission</span>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className="inline-block ml-2 h-5 w-5 text-gray-400 hover:text-white transition-colors cursor-pointer" />
            </TooltipTrigger>
            <TooltipContent>
              <p>Most people receive 5%</p>
            </TooltipContent>
          </Tooltip>
          <br />
          on every order you refer
        </h2>

        <p className="text-base text-white/80 mb-4 font-body">
          Join our affiliate program and get paid for every sale. Simple, fast payouts. No minimum traffic required.
        </p>

        <a
          href="https://battleforgepc.com/affiliates"
          className="inline-block bg-gradient-to-r from-gaming-blue to-gaming-purple text-white font-bold py-2 px-6 rounded-md shadow hover:from-gaming-purple hover:to-gaming-blue transition-all duration-150 text-base mt-1"
          target="_blank"
          rel="noopener noreferrer"
          style={{ letterSpacing: 0.5 }}
        >
          Join Affiliate Program
        </a>
      </div>
    </section>
  </TooltipProvider>
);

export default AffiliatePromoBanner;
